import type { ComboboxOptionsType } from '../types/combobox-root.types';
import { isGroup } from './is-group';

/**
 * Counts the selectable options, including options nested in groups.
 *
 * @param options - The filtered combobox options
 * @returns The number of selectable options
 */
export const getFilteredOptionsCount = (options: ComboboxOptionsType): number =>
  options.reduce((count, option) => count + (isGroup(option) ? option.options.length : 1), 0);
